// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React, { useEffect, useState } from 'react'
import { array, bool, func, oneOf, string } from 'prop-types'
import Modal from 'react-modal'
import { SearchAndSelect } from 'components'

const ModalWrapper = props => {
  const {
    closeModal,
    formName,
    getLookupTypeProps,
    label,
    lookupType,
    includeFlags,
    paginate,
    queryBasis,
    selectRow,
    unitType,
  } = props

  const [lookupTypeProps, setLookupTypeProps] = useState(null)

  useEffect(() => {
    setLookupTypeProps(getLookupTypeProps())
  }, [])

  if (!lookupTypeProps) {
    return null
  }

  const {
    initialValues,
    styles,
    // default to not auto searching. this way a given lookupType
    // can choose if it wants to auto trigger a search based on its
    // own criteria inside of getLookupTypeProps.
    triggerSearchOnMount = false,
  } = lookupTypeProps

  return (
    <Modal
      className={'modal-content-default padding-0'}
      closeModal={closeModal}
      contentLabel={'Lookup Modal'}
      isOpen={true}
      onRequestClose={closeModal}
      overlayClassName={'modal-overlay-default'}
      style={styles}>
      <SearchAndSelect
        closeModal={closeModal}
        dbSet={lookupType}
        formName={formName}
        idRoot={formName}
        includeFlags={includeFlags}
        initialValues={initialValues}
        label={label}
        paginate={paginate}
        queryBasis={queryBasis}
        selectRow={selectRow}
        triggerSearchOnMount={triggerSearchOnMount}
        unitType={unitType} />
    </Modal>
  )
}

ModalWrapper.propTypes = {
  closeModal: func.isRequired,
  formName: string.isRequired,
  getLookupTypeProps: func.isRequired,
  includeFlags: array,
  label: string.isRequired,
  lookupType: string.isRequired,
  paginate: bool,
  queryBasis: array,
  selectRow: func.isRequired,
  unitType: oneOf([
    'SI',
    'US',
  ]),
}

export default ModalWrapper
